import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { FunctionComponent, PropsWithChildren } from 'react';

export const ErrorMessage: FunctionComponent<PropsWithChildren> = ({ children }) => {
    if (children) {
        return (
            <div className="flex gap-2 break-words text-xs text-red-600" data-testid={'error-message'}>
                <ExclamationTriangleIcon className={'mt-1 size-5 shrink-0 text-red-600'} />
                <p className="line-clamp-4 text-xs font-semibold leading-6">{children}</p>
            </div>
        );
    }
};
